import { useContext } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  Checkbox
} from '@mui/material';
import { BrowseContext, BrowseContextType } from 'src/contexts/BrowseContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FilterByFormControlLabel } from '../../Layout/FilterByCheckBox';
import { FacetCount } from './FacetCount';
import { FACET_NAMES, FACET_VALUES_CPD_REQUIREMENTS } from './constants';

const FilterByCPDRequirements = () => {
  const { requirement, setRequirement, setLastChangeFacet } = useContext(
    BrowseContext
  ) as BrowseContextType;
  const handleChange = (event: any) => {
    const isChecked = event.target.checked;
    setLastChangeFacet(FACET_NAMES.RequirementsName);
    if (isChecked) {
      setRequirement([...requirement, event.target.value]);
    } else {
      const newRequirement = requirement.filter((value) => value !== event.target.value);
      setRequirement(newRequirement);
    }
  };
  const isChecked = (value: string): boolean => {
    return requirement.includes(value);
  };
  return (
    <Box>
      <Accordion defaultExpanded={true} elevation={0} disableGutters>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="requirement-content"
          id="requirement-header"
          sx={{ minHeight: 'initial' }}
        >
          <Typography variant="subtitle2" color="primary">
            CPD Requirements {requirement.length > 0 && '(' + requirement.length + ')'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingTop: 0 }}>
          <FormGroup>
            {FACET_VALUES_CPD_REQUIREMENTS.map((requirement) => (
              <FilterByFormControlLabel
                key={requirement.value}
                sx={{ width: '100%' }}
                control={
                  <Checkbox
                    onChange={handleChange}
                    value={requirement.label}
                    checked={isChecked(requirement.label)}
                  />
                }
                label={
                  <Box sx={{ display: 'flex', width: '100%' }}>
                    <Box>{requirement.label}</Box>{' '}
                    <FacetCount
                      facetName={FACET_NAMES.RequirementsName}
                      facetValueString={requirement.label}
                    />
                  </Box>
                }
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export { FilterByCPDRequirements };
